import { useState, useRef, useContext } from 'react';
import { BannerToStages, BuildPrintStage } from '../../../helpers/bannerToStages.js'
import { BannerContext } from '../../../contexts/BannerDimensionsContext';
import './index.css';
import { resizedataURL } from '../../../helpers/printElement';
import { ObjectToHtml, base64ToBlob } from '../../../helpers/formaterBanner';
import { Compress, GetBannerSize } from '../../../helpers/fileManager.js';
import { styled } from '@mui/material/styles';
import { ContainerBackup, ContainerRootStage, ContainerStep, WrapperBannerScale } from './component.js';
import Properties from '../../properties/index.js';
import { returnScaleByWidth } from '../../../helpers/scaleCalc';
import usePreviewZoom from '../../../hooks/usePreviewZoom.js';
import { useEffect } from 'react';

function Stages(banner) {

  const Root = styled('span')(
    ({ theme }) => `
    font-size: 0;
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    margin: 10px;
    cursor: pointer;
    `,
  );

  const {
    toolinfoActive,
    setGrid,
    grid,
    editGrid,
    setEditGrid,
    backgroundStage,
    layoutStage,
    showMenu,
    setCustomGrid,
    showStages,
    fullScreenRight,
    setLayoutStage,
    setBackgroundStage,
    showStep,
    setShowStep,
    propertiesActive,
    setPropertiesActive,
    tempLine,
    customGrid,
    setTempLine,
    printing,
    previewZoomToSteps,
    setPreviewZoomToSteps,
    setLoading, loading
  } = useContext(BannerContext);
  const { previewZoom } = usePreviewZoom();

  const [ history, setHistory ] = useState([JSON.parse(JSON.stringify(banner))]);
  const [ reload, setReload ] = useState(false);
  const [ shift, setShift ] = useState(false);
  const [ drag, setDrag ] = useState(null);
  const [ position, setPosition ] = useState([0, 0]);
  const [ originalPosition, setOriginalPosition ] = useState([0, 0]);
  const [ , setTooltipPosition ] = useState(0);
  const [ dbClick, setDbClick] = useState(false);
  const [ elementMiddle, setElementMiddle ] = useState([false, false]);
  const [ ctrl, setCtrl ] = useState(false);
  const [ openTooltip, setOpenTooltip ] = useState(false);
  const stages = BannerToStages(banner);
  const stagesPrint = BuildPrintStage(banner);
  const { listaReplicas, replicaActive, setListaReplicas } = useContext(BannerContext);
  const [ activeElement, setActiveElement] = useState(() => {
    try {
      const elementDiv = document.getElementById('active-element-replica').innerHTML;
      for (var i = 0; i < stages.length;  i++) {
        for (var j = 0; j < stages[i].length;  j++) {
          if (stages[i][j].id === elementDiv) {
            return [stages[i][j]];
          }
        }
      }
      return [];
    } catch(error) {
      return [];
    }
  });

  const [ stepScale ] = useState(() => {
    const stepScale = returnScaleByWidth(banner.width, banner.height).toLowerCase().replace("scale(", "").replace(")", "");
    return stepScale;
  });

  function GetMiddle() {
    if (activeElement[0]) {
      var top = activeElement[0].properties.top + parseInt(activeElement[0].properties.height * activeElement[0].properties.scale / 200);
      var left = activeElement[0].properties.left + parseInt(activeElement[0].properties.width * activeElement[0].properties.scale / 200);
      var x = false;
      var y = false;
      if (left === parseInt(banner.width / 2)) x = true;
      if (top === parseInt(banner.height / 2)) y = true;
    }
    return [x, y];
  }

  function GetMiddleDrag(left, top) {
    if (activeElement[0]) {
      top = top + parseInt(activeElement[0].properties.height * activeElement[0].properties.scale / 200);
      left = left + parseInt(activeElement[0].properties.width * activeElement[0].properties.scale / 200);
      var x = false;
      var y = false;
      if (left === parseInt(banner.width / 2)) x = true;
      if (top === parseInt(banner.height / 2)) y = true;
    }
    return [x, y];
  }


  const [backup, setBackup] = useState(() => {
    const tempBackup = [];
    for (var i = 0; i < stages.length; i++) {
      const step = stages[i];
      for (var j = 0; j < step.length; j++) {
        const el = step[j];
        if (!el.out) tempBackup.push(el);
      }
    }
    return tempBackup;
  });

  useEffect(() => {
    const tempBackup = [];
    for (var i = 0; i < stages.length; i++) {
      const step = stages[i];
      for (var j = 0; j < step.length; j++) {
        const el = step[j];
        if (!el.out) tempBackup.push(el);
      }
    }
    setBackup(tempBackup);
  }, [listaReplicas]);

  const refControlTop = useRef();
  const refControlLeft = useRef();
  const refControlScale = useRef();
  const refControlWidth = useRef();
  const refControlHeight = useRef();
  const refControlEnabled = useRef();
  const refControlProject = useRef();
  const refControlZindex = useRef();
  const refTabIndex = useRef();

  const [control, setControl] = useState({
    top: activeElement.length > 0 ? activeElement[0].properties.top : 0,
    left: activeElement.length > 0 ? activeElement[0].properties.left : 0,
    scale: activeElement.length > 0 ? activeElement[0].properties.scale : 0,
    width: activeElement.length > 0 ? activeElement[0].properties.width : 0,
    height: activeElement.length > 0 ? activeElement[0].properties.height : 0,
    color: activeElement.length > 0 ? activeElement[0].properties.color : 0,
    zIndex: activeElement.length > 0 ? activeElement[0].properties.zIndex : 0,
    enabled: activeElement.length > 0 ? activeElement[0].enabled : false,
    project: activeElement.length > 0 ? activeElement[0].project : false
  });

  if (refControlTop.current)  refControlTop.current.value = control.top;
  if (refControlLeft.current)  refControlLeft.current.value = control.left;
  if (refControlScale.current)  refControlScale.current.value = control.scale;
  if (refControlWidth.current)  refControlWidth.current.value = control.width;
  if (refControlHeight.current)  refControlHeight.current.value = control.height;
  if (refControlZindex.current)  refControlZindex.current.value = control.zIndex;
  if (refControlEnabled.current)  refControlEnabled.current.checked = control.enabled;
  if (refControlProject.current)  refControlProject.current.checked = control.project;

  function undo() {
    try {
      if (history.length > 1) {
        history.pop();
        for (var i = 0; i < banner.elements.length; i++) {
          // banner.elements[i].properties.background = history[history.length - 1].elements[i].properties.background;
          banner.elements[i].properties.blob = history[history.length - 1].elements[i].properties.blob;
          banner.elements[i].properties.height = history[history.length - 1].elements[i].properties.height;
          banner.elements[i].properties.left = history[history.length - 1].elements[i].properties.left;
          banner.elements[i].properties.opacity = history[history.length - 1].elements[i].properties.opacity;
          banner.elements[i].properties.originalBackground = history[history.length - 1].elements[i].properties.originalBackground;
          banner.elements[i].properties.position = history[history.length - 1].elements[i].properties.position;
          banner.elements[i].properties.scale = history[history.length - 1].elements[i].properties.scale;
          banner.elements[i].properties.top = history[history.length - 1].elements[i].properties.top;
          banner.elements[i].properties.transform = history[history.length - 1].elements[i].properties.transform;
          banner.elements[i].properties.width = history[history.length - 1].elements[i].properties.width;
          banner.elements[i].properties.zIndex = history[history.length - 1].elements[i].properties.zIndex;
        }
        setReload(!reload);

      }
    } catch (error) { console.log(error) }
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function changeValueAll (type, value, save = true) {
    if (loading.show) return;
    setLoading({show: true, progress: 0});
    for (var i = 0; i < activeElement.length; i++) {
      const element = activeElement[i];
      switch (type) {
        case "top":
          element.properties.top = parseInt(element.properties.top) + value;
          break;
        case "left":
          element.properties.left = parseInt(element.properties.left) + value;
          break;
        case "scale":
          var valueScale = parseInt(element.properties.scale) + value;
          if (valueScale <= 10) valueScale = 10;
          element.properties.scale = valueScale;
          if (element.reduce) {
            const bg = element.properties.originalBackground.replaceAll("'", "");
            element.properties.background = await resizedataURL(bg, element.properties.width * valueScale / 100, element.properties.height * valueScale / 100);
            const blob = base64ToBlob(element.properties.background);
            const blobUrl = URL.createObjectURL(blob);
            element.properties.blob = blobUrl;
          }
          banner.elements.forEach(children => {
            if (children.parent === element.id) {
              children.properties.scale = valueScale;
            }
          });
          break;
        case "project":
          element.project = !element.project;
          break;
        case "enabled":
          element.enabled = !element.enabled;
          break;
        case "rotate":
          var rotate = parseInt(element.properties.rotate) + value;
          if (element.properties.rotate < 0) rotate += 360;
          else if (element.properties.rotate > 360) rotate -= 360;
          element.properties.rotate = rotate;
          break;
        case "zindex":
          // element.properties.zIndex = parseInt(element.properties.zIndex) + value;
          break;
        default:
          break;
      }
    }
    
    if (save) {
      let newBanner = JSON.parse(JSON.stringify(banner));
      let newHistory = JSON.parse(JSON.stringify(history));
      newHistory.push(newBanner);
      if (newHistory.length > 6) newHistory.shift();
      setHistory(newHistory);
    }
    setLoading({show: false, progress: 0});
  }


  function changeValue(type, value) {
    let newHistory = JSON.parse(JSON.stringify(history));
    let newBanner = JSON.parse(JSON.stringify(banner));
    newHistory.push(newBanner);
    if (newHistory.length > 6) newHistory.shift();
    setHistory(newHistory);

    if (type === "color") {
      activeElement[0].properties.color = value;
      // setReload(!reload);
      return;
    }
    if (type === "enabled") {
      activeElement[0].enabled = value;
      // setReload(!reload);
      return;
    }
    if (type === "project") {
      activeElement[0].project = value;
      // setReload(!reload);
      return;
    }
    if (!value) value = 0;
    try {
      value = parseInt(value);
      switch(type) {
        case "top":
          activeElement[0].properties.top = value;
          break;
        case "left":
          activeElement[0].properties.left = value;
          break;
        case "width":
          activeElement[0].properties.width = value;
          break;
        case "height":
          activeElement[0].properties.height = value;
          break;
        case "fontSize":
          activeElement[0].properties.fontSize = value;
          break;
        case "zindex":
          activeElement[0].properties.zIndex = value;
          break;
        case "scale":
          activeElement[0].properties.scale = value;
          break;
        default:
          break;
      }
    } catch(error) { }
    setElementMiddle(GetMiddle());
    // setReload(!reload);
  }

  function getNextElement(count) {
    const step = activeElement[0].step;
    const stage = stages[step - 1];
    var index = -1;
    for (var i = 0; i < stage.length; i++){
      if (stage[i].id === activeElement[0].id) {
        index = i;
        break;
      }
    }
    if (count === 1 && index >= stage.length - 1) index = 0;
    if (count === -1 && index === 0) index = stage.length - 1;
    setActiveElement([stage[index + count]]);
    document.getElementById('active-element-replica').innerHTML = stage[index + count].id;
  }

  function getChildrenPosition(parent, children, position, direction) {
    var pos = 0;
    try {
      if (parent) {
        banner.elements.forEach(element => {
          if (element.id === parent) {
            if (direction === "left") {
              pos = parseInt(element.properties.left);
            }
            else {
              pos = parseInt(element.properties.top);
            }
          }
        });
      } else return position;
    } catch { return position; }
    pos += position * children.properties.scale / 100;
    return pos;
  }

  function setClassButton(element) {
    let className =  "botao_layer"
    activeElement.forEach(el => {
      if (el.id === element) className =  "botao_layer botao_focus";
    });
    return className;
  }

  function changeShowStep(index) {
    let copyShow = JSON.parse(JSON.stringify(showStep));
    copyShow[index].show = !copyShow[index].show;
    setShowStep(copyShow);
  }

  async function changeValueTooltip(type, value, id) {
    for (var i = 0; i < activeElement.length; i++) {
      var element = activeElement[i];
      if (id !== element.id) continue;
      switch (type) {
        case "top":
          element.properties.top = value;
          break;
        case "left":
          element.properties.left = value;
          break;
        case "scale":
          var valueScale = value;
          if (valueScale <= 10) valueScale = 10;
          element.properties.scale = valueScale;

          banner.elements.forEach(children => {
            if (children.parent === element.id) {
              children.properties.scale = valueScale;
            }
          });
          break;
        case "project":
          element.project = !element.project;
          break;
        case "enabled":
          element.enabled = !element.enabled;
          break;
        case "rotate":
          var rotate = parseInt(element.properties.rotate) + value;
          if (element.properties.rotate < 0) rotate += 360;
          else if (element.properties.rotate > 360) rotate -= 360;
          element.properties.rotate = rotate;
          break;
        case "zindex":
          // element.properties.zIndex = parseInt(element.properties.zIndex) + value;
          break;
        case "align_top":
          element.properties.top = 0;
          break;
        case "align_right":
          element.properties.left = parseInt(banner.width - element.properties.width * parseInt(element.properties.scale) / 100);
          break;
        case "align_down":
          element.properties.top = parseInt(banner.height - element.properties.height * parseInt(element.properties.scale) / 100);
          break;
        case "align_left":
          element.properties.left = 0;
          break;
        case "align_horizontal":
          element.properties.left = parseInt(banner.width / 2 - element.properties.width * parseInt(element.properties.scale) / 200);
          break;
        case "align_vertical":
          element.properties.top = parseInt(banner.height / 2 - element.properties.height * parseInt(element.properties.scale) / 200);
          break;
        case "align_center":
          element.properties.left = parseInt(banner.width / 2 - element.properties.width * parseInt(element.properties.scale) / 200);
          element.properties.top = parseInt(banner.height / 2 - element.properties.height * parseInt(element.properties.scale) / 200);
          break;
        default:
          break;
        }
    }

    let newHistory = JSON.parse(JSON.stringify(history));
    let newBanner = JSON.parse(JSON.stringify(banner));
    newHistory.push(newBanner);
    if (newHistory.length > 6) newHistory.shift();
    setHistory(newHistory);
    setReload(!reload)
  }

  const [collapsedDivs, setCollapsedDivs] = useState([]);

  const handleCollapse = (index) => {
    const divsUpdated = [...collapsedDivs];
    divsUpdated[index] = !divsUpdated[index];
    setCollapsedDivs(divsUpdated);
  };

	const handleSelectChange = async (event) => {
    try {
      var copyReplicas = JSON.parse(JSON.stringify(listaReplicas));
      for (var i = 0; i < copyReplicas.length; i++) {
        const replica = copyReplicas[i];
        if (`${replica.width}x${replica.height}` === replicaActive) {
          const optimize = event.target.value;
          replica.optimize = optimize;
          for (var j = 0; j < replica.elements.length; j++) {
            try {
              const element = replica.elements[j];
              var originalBG = element.properties.originalBackground.replaceAll("'", "");

              if (optimize < 100) {
                element.properties.background = await Compress(originalBG, optimize);
              } else {
                element.properties.background = originalBG;
              }
            } catch (error) { console.log(error) }
          }
        }
        replica.html = ObjectToHtml(replica, true);
        const html = ObjectToHtml(replica);
        replica.size = GetBannerSize(html);
      }
      setListaReplicas(copyReplicas);
    } catch (error) { console.log(error) }
	};

  const [ customIndex, setCustomIndex ] = useState(() => {
    const customIndex = customGrid.findIndex(x => x.width === banner.width && x.height === banner.height);
    return customIndex;
  });

  const [refElementResizing, setRefElementResizing] = useState(null);
  let resize = {
    aspect: 1
  }
  
  function handleMouseDown(evt) {
    evt.stopPropagation();
    setRefElementResizing(activeElement[0]);
    resize.aspect = activeElement[0].properties.height / activeElement[0].properties.width;
  }

  function handleMove(evt) {
    resize.move += evt.movementX * resize.aspect > evt.movementY ? evt.movementX : evt.movementY;
    let element = activeElement[0];

    let divElement = document.getElementById("elementStage" + banner.width + "x" + banner.height + "_" + element.id);
    if (divElement) {
      let width = divElement.style.width.replace("px", "");
      let height = divElement.style.height.replace("px", "");
      divElement.style.width = parseInt(width) + evt.movementX + "px";
      divElement.style.height = parseInt(height) + evt.movementY + "px";
    }
    let divElementBorder = document.getElementById("elementStage" + banner.width + "x" + banner.height + "_" + element.id + "Border");
    if (divElementBorder) {
      let width = divElementBorder.style.width.replace("px", "");
      let height = divElementBorder.style.height.replace("px", "");
      divElementBorder.style.width = parseInt(width) + evt.movementX + "px";
      divElementBorder.style.height = parseInt(height) + evt.movementY + "px";
    }
  }

  function handleMouseUp() {
    let element = JSON.parse(JSON.stringify(refElementResizing));
    let width = element.properties.width;
    let height = element.properties.height;
    let divElement = document.getElementById("elementStage" + banner.width + "x" + banner.height + "_" + element.id);
    let divWidth = divElement.style.width.replace("px", "");
    let divHeight = divElement.style.height.replace("px", "");
    let scaleX = 100 + (divWidth - width) / width * 100;
    let scaleY = 100 + (divHeight - height) / height * 100;

    let scale = scaleX < scaleY ? scaleX : scaleY;
    activeElement[0].properties.scale = scale;
    setRefElementResizing(null);
  }

  return (
    <div
      ref={refTabIndex}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outline: 'none',
        position: 'relative',
        pointerEvents: 'auto'
      }}
      tabIndex='0'
      onKeyDown={(evt) => {
        if (evt.key === "Control" || evt.key === "Meta") {
          setCtrl(true);
         }
         else if (evt.key === "z" && ctrl) {
          undo();
        }
        else {
          if (activeElement.length === 0) return
          var step = 1;
          if (shift) step = 10;
          if (evt.code === "KeyE") getNextElement(1);
          else if (evt.code === "KeyQ") getNextElement(-1);
          else if (evt.code === "KeyR") changeValueAll("rotate", step === 10 ? 30 : 5);
          else if (evt.code === "ShiftLeft") setShift(true);
          else if (evt.code === "KeyP") changeValueAll("project", true);
          else if (evt.code === "Delete") changeValueAll("enabled", true);
          else if (evt.code === "KeyG" ) setGrid(!grid);
          else if (evt.code === "KeyV" ) changeValue("left", parseInt(banner.width / 2) - parseInt(activeElement[0].properties.width * activeElement[0].properties.scale / 200));
          else if (evt.code === "KeyH" ) changeValue("top", parseInt(banner.height / 2) - parseInt(activeElement[0].properties.height * activeElement[0].properties.scale / 200));
        }
      }}
      onKeyUp={(evt) => {
        if (evt.key === "Control" || evt.key === "Meta") setCtrl(false);
        else if(evt.code === "ShiftLeft") setShift(false);

        var step = 1;
        if (shift) step = 10;
        if (evt.code === "KeyW") changeValueAll("top", -step);
        else if (evt.code === "KeyS" ) changeValueAll("top", step);
        else if (evt.code === "KeyD" ) changeValueAll("left", step);
        else if (evt.code === "KeyA" ) changeValueAll("left", -step);
        else if (!ctrl && (evt.code === "NumpadSubtract" || evt.code === "Minus" || evt.code === "KeyZ")) changeValueAll("scale", -15);
        else if (!ctrl && (evt.code === "NumpadAdd" || evt.code === "Equal" || evt.code === "KeyX")) changeValueAll("scale", 15);
        }}
      >
      <span id="active-element-replica" style={{display: 'none'}}></span>
    {listaReplicas.length > 0 && !fullScreenRight ?
      <Properties
        fullScreenRight={fullScreenRight}
        setPropertiesActive={setPropertiesActive}
        propertiesActive={propertiesActive}
        banner={banner}
        customGrid={customGrid}
        setCustomGrid={setCustomGrid}
        setLayoutStage={setLayoutStage}
        layoutStage={layoutStage}
        showMenu={showMenu}
        showStep={showStep}
        changeShowStep={changeShowStep}
        handleCollapse={handleCollapse}
        collapsedDivs={collapsedDivs}
        setReload={setReload}
        reload={reload}
        activeElement={activeElement}
        setActiveElement={setActiveElement}
        setClassButton={setClassButton}
        setOpenTooltip={setOpenTooltip}
        openTooltip={openTooltip}
        editGrid={editGrid}
        handleSelectChange={handleSelectChange}
        setTempLine={setTempLine}
        setEditGrid={setEditGrid}
        setGrid={setGrid}
        grid={grid}
        backgroundStage={backgroundStage}
        setBackgroundStage={setBackgroundStage}
        Root={Root}
        showStages={showStages}
        changeValueTooltip={changeValueTooltip}
        setPreviewZoomToSteps={setPreviewZoomToSteps}
        previewZoomToSteps={previewZoomToSteps}
      />
      :<></>}
      <ContainerRootStage
        className="root-stages"
        id={"id-root-stages-" + banner.width + "x" + banner.height}
        layoutStage={layoutStage}
        width={banner.width}
        style={{ marginBottom: layoutStage ? `${banner.height}px` : '' }}
        onMouseUp={(evt)  => {
          if (refElementResizing) handleMouseUp();
        }}
        onMouseMove={(evt) => {
          if (editGrid && tempLine === 'y') {
            var rect = document.getElementById("id-root-stages-" + banner.width + "x" + banner.height).getBoundingClientRect();
            const x = evt.clientX - rect.left;
            const y = evt.clientY - rect.top;
            document.getElementById("id-svg-tempgridY-" + banner.width + "x" + banner.height).style.top = y + "px";
            document.getElementById("id-svg-tempgridY-" + banner.width + "x" + banner.height + "-span").style.top = (y - 50) + "px";
            document.getElementById("id-svg-tempgridY-" + banner.width + "x" + banner.height + "-span").style.left = (x + 10) + "px";
          } else if (refElementResizing) {
            handleMove(evt, refElementResizing);
          }
        }}
        >
          {
            customIndex > -1 ?
              customGrid[customIndex].x.map((item, index) =>
                <div key={`rulerX-${index}`}
                  id="ruleLineX"
                  style={{width: '1px',
                    height: '100%',
                    background: 'purple',
                    position: 'absolute',
                    top: '36px',
                    left: `${item}px`,
                    zIndex: 99999999
                  }}
                />
              ) : <></>
          }
          {
            customIndex > -1 ?
              customGrid[customIndex].y.map((item, index) =>
                <div key={`rulerY-${index}`}
                  id="ruleLineY"
                  style={{width: layoutStage ? '100%' : `${previewZoomToSteps && previewZoom ?
                    banner.width * previewZoom : banner.width}px`,
                    height: '1px',
                    background: 'purple',
                    position: 'absolute',
                    top: `${item}px`,
                    left: previewZoomToSteps && previewZoom > 0 ? `${30 * previewZoom}px` : `30px`,
                    zIndex: 99999999
                  }}
                />
              ) : <></>
          }
          {
            editGrid ?
              tempLine === 'x' ?
              <>
                <div id={"id-svg-tempgridX-" + banner.width + "x" + banner.height + "-span"} className='custom-grid-tooltip' />
                <div id={"id-svg-tempgridX-" + banner.width + "x" + banner.height} className='custom-grid-line line-x'/>
              </>
                  : tempLine === 'y'
                ?
                <>
                  <div id={"id-svg-tempgridY-" + banner.width + "x" + banner.height + "-span"} className='custom-grid-tooltip' />
                  <div
                    id={"id-svg-tempgridY-" + banner.width + "x" + banner.height}
                    className='custom-grid-line line-y'
                    style={{width:
                      layoutStage ? '100%' :
                        previewZoomToSteps && previewZoom > 0 ?
                        `${banner.width * previewZoom}px` :
                      `${banner.width}px`,
                      left: previewZoomToSteps && previewZoom > 0 ? `${30 * previewZoom}px` : `30px`,
                    }}
                  />
                </>
              : <></>
            : <></>
          }
        {
          printing ?
            stagesPrint.map((steps, index) =>
              <div style={{width: `${banner.width}px`, height: `${banner.height}px`, position: 'relative'}} id={`id-stage-${banner.width}-${banner.height}-step-${index + 1}`}>
                {steps.map(el =>
                  <div
                    key={Math.random()}
                    style={{
                      background: el.properties.blob ? "url('" + el.properties.blob + "') no-repeat": "",
                      backgroundColor: el.properties.backgroundColor ? el.properties.backgroundColor : "",
                      width: Math.ceil(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                      height: Math.ceil(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px",
                      left: el.parent ? getChildrenPosition(el.parent, el, el.properties.left, "left") + "px" : el.properties.left  + "px",
                      top: el.parent ? getChildrenPosition(el.parent, el, el.properties.top,  "top") + "px" : el.properties.top  + "px",
                      opacity:  1,
                      position: el.properties.position,
                      backgroundSize: el.optmize ? '' : (el.type === 'bg' ? 'cover' : 'contain'),
                      cursor: 'pointer',
                      zIndex: el.properties.zIndex - 1,
                      display: 'block',
                      pointerEvents: 'none'
                    }}>
              </div>)}
            </div>)
          : <></>
        }
        {
        stages.map((steps, index) =>
        <div className="list-stages" key={`${banner}x${banner} - ${index}`} style={{
          display: showStep[index].show ? 'block' : 'none',
          marginTop: previewZoomToSteps && previewZoom > 1 ? `${10 * previewZoom}px` : '',
          zoom: previewZoomToSteps && previewZoom > 0
            ? banner.width >= 700 && banner.height >= 700
              ? previewZoom * 2.5
              : previewZoom
            : '100%',
          paddingLeft: previewZoomToSteps && banner.width > 700 && banner.height > 700 ? '15px' : '30px'
        }}>
          <span style={{color: 'black', fontSize: '18px', fontWeight: 'bold', userSelect: 'none', marginBottom: '60px'}}>Step {index + 1}</span>
          <WrapperBannerScale width={banner.width} height={banner.height}>
            <div>
              <ContainerStep
                id={`id-stage-${banner.width}-${banner.height}-step-${index + 1}`}
                width={banner.width}
                height={banner.height}
                onMouseUp={(evt) => {
                  if (refElementResizing) return;
                  if (editGrid && tempLine) return;
                  if (!shift) {
                    const left = evt.clientX - originalPosition[0];
                    const top = evt.clientY - originalPosition[1];
                    changeValueAll("left", left, false);
                    changeValueAll("top", top);
                  }
                  setDrag(null);
                    refTabIndex.current.focus({ preventScroll: true });
                }}
                onMouseMove={(evt) => {
                    if (editGrid && tempLine === 'x') {
                    var rect = document.getElementById("id-root-stages-" + banner.width + "x" + banner.height).getBoundingClientRect();
                    const x = evt.clientX - rect.left;
                    const y = evt.clientY - rect.top;
                    document.getElementById("id-svg-tempgridX-" + banner.width + "x" + banner.height).style.left = `${x}px`;
                    document.getElementById("id-svg-tempgridX-" + banner.width + "x" + banner.height + "-span").style.left = `${(x + 10)}px`;
                    document.getElementById("id-svg-tempgridX-" + banner.width + "x" + banner.height + "-span").style.top = `${(y - 50)}px`;
                    document.getElementById("id-svg-tempgridX-" + banner.width + "x" + banner.height + "-span").innerHTML =  `x: ${(x / stepScale).toFixed(0)}px`;
                  } else if (editGrid && tempLine === 'y') {
                    const divStep = document.getElementById(`id-stage-${banner.width}-${banner.height}-step-${index + 1}`).getBoundingClientRect();
                    let yStep = evt.clientY - divStep.top;
                    yStep = yStep < 0 ? null : yStep > banner.height ? null : parseInt(yStep / stepScale);
                    document.getElementById("id-svg-tempgridY-" + banner.width + "x" + banner.height + "-span").innerHTML = yStep ? `y: ${previewZoomToSteps && previewZoom > 0 ? Math.round(yStep / previewZoom) : yStep}px` : '';
                  } else if (drag && !shift) {
                    var id = drag[1].replace("Border", "");
                    var svg = document.getElementById("svg_line_stage" + activeElement[0].step);
                    var lineX = document.getElementById("line_stage_x_" + activeElement[0].step);
                    var lineY = document.getElementById("line_stage_y_" + activeElement[0].step);
                    var div = document.getElementById(id);
                    const left = evt.clientX - originalPosition[0];
                    const top = evt.clientY - originalPosition[1];
                    try {
                      div.style.top = parseInt(position[1]) + parseInt(top) + "px";
                      div.style.left = parseInt(position[0]) + parseInt(left) + "px";
                      svg.style.top = (parseInt(position[1]) + parseInt(top) - banner.height + activeElement[0].properties.height * activeElement[0].properties.scale / 200) + "px";
                      svg.style.left = (parseInt(position[0]) + parseInt(left) - banner.width + activeElement[0].properties.width * activeElement[0].properties.scale / 200) + "px";
                    } catch (e) { }
                    var newSvgPos = GetMiddleDrag(parseInt(position[0]) + parseInt(left), parseInt(position[1]) + parseInt(top));
                    if (newSvgPos[0]) lineX.style.stroke = 'red';
                    else lineX.style.stroke = 'cyan';
                    if (newSvgPos[1]) lineY.style.stroke = 'red';
                    else lineY.style.stroke = 'cyan';
                  }
                }}
                onMouseDown={(evt) => {
                  if (editGrid && tempLine) {
                    const rect = document.getElementById("id-root-stages-" + banner.width + "x" + banner.height).getBoundingClientRect();
                    let copyCustomGrid = JSON.parse(JSON.stringify(customGrid));
                    if (tempLine === 'x') {
                      copyCustomGrid[customIndex].x.push(evt.clientX - rect.left);
                    } else if (tempLine === 'y'){
                      copyCustomGrid[customIndex].y.push(evt.clientY - rect.top);
                    }
                    setCustomGrid(copyCustomGrid);
                    setTempLine(null);
                  } else {
                    setTooltipPosition(evt.pageY);
                    setOriginalPosition([evt.clientX, evt.clientY]);
                  }
                }}
                className="container-step"
                style={{background: backgroundStage ? 'black' : banner.backgroundColor ? banner.backgroundColor : 'transparent', width: banner.width + "px", height: banner.height + "px"}}
              >
                <svg
                  id={"svg_line_stage" + (index + 1)}
                  style={{
                    display: activeElement[0] &&  grid ? activeElement[0].step === (index + 1) ? "flex" : "none" : "none",
                    width: (banner.width * 2) + "px",
                    height: (banner.height * 2 )+ "px",
                    top: activeElement[0] ? (activeElement[0].properties.top - banner.height + activeElement[0].properties.height * activeElement[0].properties.scale / 200) + "px" : "0px",
                    left: activeElement[0] ? (activeElement[0].properties.left - banner.width + activeElement[0].properties.width * activeElement[0].properties.scale / 200) + "px" : "0px",
                    pointerEvents: 'none',
                    position: 'absolute',
                    zIndex: 999
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1">
                  <line
                    id={"line_stage_x_" + (index + 1)}
                    x1={banner.width} x2={banner.width}
                    y2={banner.height * 2} y1="0"
                    style={{stroke: !elementMiddle[0] ? 'cyan' : 'red', strokeWidth: '1'}} />
                  <line
                    id={"line_stage_y_" + (index + 1)}
                    x1="0" x2={banner.width * 2}
                    y1={banner.height} y2={banner.height}
                    style={{stroke: !elementMiddle[1] ? 'cyan' : 'red', strokeWidth: '1'}} />
                </svg>
                <div style={{display: grid ? 'flex' : 'none'}}>
                <div
                  className="container-elementstage-grid"
                  id={"grid-elementStage" + banner.width + "x" + banner.height + "_x1"}
                  style={{
                    display: layoutStage ? activeElement.find(x => x.step === index + 1) ? 'flex' : 'none' : 'flex',
                    position: 'absolute',
                    zIndex: 999,
                    left: activeElement.length > 0 ? activeElement[0].properties.left : 0,
                    width: "0px",
                    height: banner.height
                  }}
                  ></div>
                  <div
                    className="container-elementstage-grid"
                    id={"grid-elementStage" + banner.width + "x" + banner.height + "_x2"}
                    style={{
                      display: layoutStage ? activeElement.find(x => x.step === index + 1) ? 'flex' : 'none' : 'flex',
                      position: 'absolute',
                      zIndex: 999,
                      left: activeElement.length > 0 ?
                        activeElement[0].properties.left + (activeElement[0].properties.width * activeElement[0].properties.scale / 100) + 1.5: 0,
                      width: "0px",
                      height: banner.height
                    }}
                  ></div>
                  <div
                    className="container-elementstage-grid"
                    id={"grid-elementStage" + banner.width + "x" + banner.height + "_y1"}
                    style={{
                      display: !layoutStage ? activeElement.find(x => x.step === index + 1) ? 'flex' : 'none' : 'flex',
                      position: 'absolute',
                      zIndex: 999,
                      top: activeElement.length > 0 ? activeElement[0].properties.top : 0,
                      width: banner.width,
                      height: '0px'
                    }}
                  ></div>
                  <div
                    className="container-elementstage-grid"
                    id={"grid-elementStage" + banner.width + "x" + banner.height + "_y2"}
                    style={{
                      display: !layoutStage ? activeElement.find(x => x.step === index + 1) ? 'flex' : 'none' : 'flex',
                      position: 'absolute',
                      zIndex: 999,
                      top: activeElement.length > 0 ?
                        activeElement[0].properties.top + (activeElement[0].properties.height * activeElement[0].properties.scale / 100) + 1: 0,
                      width: banner.width,
                      height: '0px'
                    }}
                  ></div>
                </div>
                {steps.map(el =>
                  <div
                  id={"elementStage" + banner.width + "x" + banner.height + "_" + el.id}
                  key={Math.random()}
                  style={{
                    background: el.properties.blob ? "url('" + el.properties.blob + "') no-repeat": "",
                    backgroundColor: el.properties.type === 'video' ? 'rgba(0,0,255,0.2' : el.properties.backgroundColor ? el.properties.backgroundColor : "",
                    width: Math.ceil(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                    height: Math.ceil(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px",
                    left: el.parent ? getChildrenPosition(el.parent, el, el.properties.left, "left") + "px" : el.properties.left  + "px",
                    top: el.parent ? getChildrenPosition(el.parent, el, el.properties.top,  "top") + "px" : el.properties.top  + "px",
                    transform: el.properties.rotate !== "0" ? "rotate(" + el.properties.rotate + "deg)" : "",
                    opacity: el.parent ? banner.elements.find(x => x.id === el.parent).enabled ? 1 : 0.2 : el.enabled ? 1 : 0.2,
                    position: el.properties.position,
                    backgroundSize: el.optmize ? '' : (el.type === 'bg' ? 'cover' : 'contain'),
                    cursor: 'pointer',
                    zIndex: el.properties.zIndex
                  }}
                  onMouseDown={(evt => {
                    if (editGrid && tempLine) {
                      //TODO
                    } else {
                      var elementParent = el;
                      if (el.parent) {
                        banner.elements.forEach(parent => {
                          if (parent.id === el.parent) {
                            elementParent = parent;
                          }
                        });
                      }
                      if (!shift) setDrag([elementParent, evt.target.id]);
                      setPosition([elementParent.properties.left , elementParent.properties.top])
                      setActiveElement([]);
                      if (shift) {
                        activeElement.push(elementParent);
                        setActiveElement(activeElement);
                      } else {
                        setActiveElement([elementParent]);
                      }
                      if (dbClick) {
                        changeValueAll("zindex", -1);
                      }
                      setDbClick(true);
                      document.getElementById('active-element-replica').innerHTML = elementParent.id;
                      setTimeout(() => {
                        setDbClick(false);
                      }, 500)
                    }
                  })}>
                    <div
                      className="container-elementstage"
                      id={"elementStage" + banner.width + "x" + banner.height + "_" + el.id + "Border"}
                      style={{
                        display: activeElement.find(x => x.id === el.id) ? 'flex' : 'none',
                        position: 'absolute',
                        width: Math.round(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                        height: Math.round(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px",
                      }}
                      >
                      <div
                        onMouseDown={(evt) => handleMouseDown(evt, el)}
                        className='resize-handle'
                        style={{display: activeElement.length === 1 ? 'block' : 'none', right: `${previewZoom ? -10 / previewZoom : -10}px`, bottom:`${previewZoom ? -10 / previewZoom : -10}px`, width: `${previewZoom ? 15 / previewZoom : 15}px`, height: `${previewZoom ? 15 / previewZoom : 15}px`, border: `${previewZoom ? 3 / previewZoom : 3}px solid yellow`}}>                            
                      </div>
                    </div>
                  </div>
                )}
                {stages.map((stepsProject, indexProject) =>
                index > indexProject ?
                stepsProject.map(el =>
                  el.project ?
                  <div
                    key={Math.random()}
                    style={{
                      background: el.properties.blob ? "url('" + el.properties.blob + "') no-repeat": "",
                      backgroundColor: el.properties.backgroundColor ? el.properties.backgroundColor : "",
                      width: Math.ceil(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                      height: Math.ceil(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px",
                      left: el.parent ? getChildrenPosition(el.parent, el, el.properties.left, "left") + "px" : el.properties.left  + "px",
                      top: el.parent ? getChildrenPosition(el.parent, el, el.properties.top,  "top") + "px" : el.properties.top  + "px",
                      opacity: 0.2,
                      position: el.properties.position,
                      backgroundSize: el.optmize ? '' : (el.type === 'bg' ? 'cover' : 'contain'),
                      // backgroundSize: el.type === 'bg' ? 'cover' : 'contain',
                      cursor: 'pointer',
                      zIndex: el.properties.zIndex,
                      display: (!el.properties.blob && !el.properties.backgroundColor && !el.properties.text) ? 'none' : 'block',
                      pointerEvents: 'none'
                    }}>
                        <div
                          className="container-project"
                          style={{
                            width: Math.round(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                            height: Math.round(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px"
                          }}>
                        </div>
                    </div>
                    : null
                  )
                  : null
                )}
              </ContainerStep>
            </div>
          </WrapperBannerScale>
        </div>
        )}
        <WrapperBannerScale width={banner.width} height={banner.height}
          style={{
            zoom: previewZoomToSteps && previewZoom > 0
              ? banner.width >= 700  && banner.height >= 700
                ? previewZoom * 2.5
                : previewZoom
              :   '100%',
            marginLeft: previewZoomToSteps && banner.width > 700 && banner.height > 700 ? '15px' : '30px',
            paddingTop: '3px',
            marginTop: previewZoomToSteps && previewZoom > 1 ? `${10 * previewZoom}px` : '',
            marginBottom: `${banner.height / 4}px`
          }}
        >
          <p style={{margin: 0, color: 'black', fontSize: '18px', paddingBottom: banner.width > 1000 ? '10px' : '0', fontWeight: 'bold'}}>Backup</p>
          <ContainerBackup
            key={Math.random()}
            width={banner.width}
            height={banner.height}
          >
            <div
              id = {"replica_" + banner.width + "x" + banner.height + "_backup"}
              style={{
                background: banner.backgroundColor ? banner.backgroundColor : "white",
                display: 'block',
                position: 'relative',
                width: banner.width + "px",
                height: banner.height + "px",
                overflow: 'hidden',
                marginBottom: `${banner.height / 4}px`,
              }}>
              {backup.map(el =>
                <div
                    id="elementStageBackup"
                    style={{
                      background: el.properties.blob ? "url('" + el.properties.blob + "') no-repeat": "",
                      backgroundColor: el.properties.backgroundColor ? el.properties.backgroundColor : "",
                      width: Math.round(el.properties.width * el.properties.scale / 100).toFixed(0) + "px",
                      height: Math.round(el.properties.height * el.properties.scale / 100).toFixed(0)  + "px",
                      left: el.parent ? getChildrenPosition(el.parent, el, el.properties.left, "left") + "px" : el.properties.left  + "px",
                      top: el.parent ? getChildrenPosition(el.parent, el, el.properties.top,  "top") + "px" : el.properties.top  + "px",
                      opacity: el.enabled ? 1 : 0,
                      position: el.properties.position,
                      backgroundSize: el.optmize ? '' : (el.type === 'bg' ? 'cover' : 'contain'),
                      zIndex: el.properties.zIndex
                    }}>
                  </div>
                )}
            </div>
          </ContainerBackup>
        </WrapperBannerScale>
      </ContainerRootStage>
      <div
        className="stage-control"
        style={{
          width: toolinfoActive && activeElement.length > 0 ? '380px' : '0px',
          position: 'absolute',
          right: 0,
          }}
        >
      </div>
    </div>
  )
}

export default Stages;